import React from 'react';

const UNITS = ['', 'یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه'];
const TEENS = [
    'ده',
    'یازده',
    'دوازده',
    'سیزده',
    'چهارده',
    'پانزده',
    'شانزده',
    'هفده',
    'هجده',
    'نوزده',
];
const TENS = ['', '', 'بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود'];
const HUNDREDS = ['', 'یکصد', 'دویست', 'سیصد', 'چهارصد', 'پانصد', 'ششصد', 'هفتصد', 'هشتصد', 'نهصد'];
const THOUSANDS = ['', 'هزار', 'میلیون', 'میلیارد'];

function convertThreeDigits(number) {
    const h = Math.floor(number / 100);
    const t = Math.floor((number % 100) / 10);
    const u = number % 10;
    const parts = [];

    if (h) parts.push(HUNDREDS[h]);
    if (t === 1) {
        parts.push(TEENS[u]);
    } else {
        if (t) parts.push(TENS[t]);
        if (u) parts.push(UNITS[u]);
    }

    return parts.join(' ').trim();
}

function numberToPersianWords(originalNumber) {
    if (!originalNumber && originalNumber !== 0) return 'صفر';
    if (!originalNumber) return '';

    let number = Number(String(originalNumber).replace(/[^\d]/g, ''));
    const words = [];
    let i = 0;

    while (number > 0) {
        const chunk = number % 1000;
        if (chunk) {
            const chunkWords = convertThreeDigits(chunk);
            if (THOUSANDS[i]) {
                words.unshift(`${chunkWords} ${THOUSANDS[i]}`.trim());
            } else {
                words.unshift(chunkWords);
            }
        }
        number = Math.floor(number / 1000);
        i += 1;
    }

    return `${words.join(' ')} تومان`;
}

const PersianNumber2Words = function PersianNumber2Words({ value }) {
    if (value === null || value === undefined) return null;
    return <span>{numberToPersianWords(value)}</span>;
};

export default PersianNumber2Words;
